import React, { useContext, useState } from 'react';
import { block } from 'bem-cn';
import ReactDOM from 'react-dom';

import { ModalContext } from '../ModalProvider';
import './Modal.scss';

const b = block('modal');

const Modal = ({ content, title, isMobile, closeFunction, withoutBG, disableOverlayClose = false }) => {
  const { closeModal } = useContext(ModalContext);

  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);

    const closeTimeout = setTimeout(() => {
      closeModal();
      clearTimeout(closeTimeout);
      closeFunction && closeFunction();
    }, 175);
  };

  const handleOverlayClick = () => {
    if (disableOverlayClose) return;
    handleClose();
  };

  const layout = (
    <div onClick={handleOverlayClick} className={b({ disappearing: isClosing })}>
      <div onClick={e => e.stopPropagation()} className={b('body', { disappearing: isClosing, isMobile, withoutBG })}>
        <div className={b('content', { isMobile })}>{content}</div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(layout, document.getElementById('modal-root'));
};

export default Modal;
